module.exports = __webpack_public_path__ + "static/media/policies-for-pdf.c0969bd4.png";